module.exports = __webpack_public_path__ + "img/hz_37.7f0567d9.png";